<template>
    <form method="post" action="" v-on:submit="submitForm">
        <div class="form-section">
            <div class="form-group">
                <label>Account status: *</label><br />
                <select v-model="finalData.isEnabled">
                    <option value="true">Enabled</option>
                    <option value="false">Disabled</option>
                </select>
            </div>
        </div>

        <h3>Lab Information</h3>
        <div class="form-section">
            <div class="form-group">
                <label>Email: *</label><br />
                <input type="text" name="email" v-model="finalData.email" />
            </div>
            <div class="form-group">
                <label>Name: *</label><br />
                <input type="text" name="name" v-model="finalData.name" />
            </div>
            <div class="form-group">
                <label>Owner/Manager Name: *</label><br />
                <input type="text" name="website" v-model="finalData.ownerName" />
            </div>
            <div class="form-group">
                <label>Phone: *</label><br />
                <input type="text" name="phone" v-model="finalData.phone" />
            </div>
            <div class="form-group">
                <label>Website: *</label><br />
                <input type="text" name="website" v-model="finalData.website" />
            </div>
        </div>


        <h3>Location</h3>
        <div class="form-section">
            <div class="form-group">
                <label>Country: *</label><br />
                <select id="country" name="country" v-model="country" class="form-control">
                    <option value="">Select Country</option>
                    <option value="AF">Afghanistan</option>
                    <option value="AX">Åland Islands</option>
                    <option value="AL">Albania</option>
                    <option value="DZ">Algeria</option>
                    <option value="AS">American Samoa</option>
                    <option value="AD">Andorra</option>
                    <option value="AO">Angola</option>
                    <option value="AI">Anguilla</option>
                    <option value="AQ">Antarctica</option>
                    <option value="AG">Antigua and Barbuda</option>
                    <option value="AR">Argentina</option>
                    <option value="AM">Armenia</option>
                    <option value="AW">Aruba</option>
                    <option value="AU">Australia</option>
                    <option value="AT">Austria</option>
                    <option value="AZ">Azerbaijan</option>
                    <option value="BS">Bahamas</option>
                    <option value="BH">Bahrain</option>
                    <option value="BD">Bangladesh</option>
                    <option value="BB">Barbados</option>
                    <option value="BY">Belarus</option>
                    <option value="BE">Belgium</option>
                    <option value="BZ">Belize</option>
                    <option value="BJ">Benin</option>
                    <option value="BM">Bermuda</option>
                    <option value="BT">Bhutan</option>
                    <option value="BO">Bolivia, Plurinational State of</option>
                    <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
                    <option value="BA">Bosnia and Herzegovina</option>
                    <option value="BW">Botswana</option>
                    <option value="BV">Bouvet Island</option>
                    <option value="BR">Brazil</option>
                    <option value="IO">British Indian Ocean Territory</option>
                    <option value="BN">Brunei Darussalam</option>
                    <option value="BG">Bulgaria</option>
                    <option value="BF">Burkina Faso</option>
                    <option value="BI">Burundi</option>
                    <option value="KH">Cambodia</option>
                    <option value="CM">Cameroon</option>
                    <option value="CA">Canada</option>
                    <option value="CV">Cape Verde</option>
                    <option value="KY">Cayman Islands</option>
                    <option value="CF">Central African Republic</option>
                    <option value="TD">Chad</option>
                    <option value="CL">Chile</option>
                    <option value="CN">China</option>
                    <option value="CX">Christmas Island</option>
                    <option value="CC">Cocos (Keeling) Islands</option>
                    <option value="CO">Colombia</option>
                    <option value="KM">Comoros</option>
                    <option value="CG">Congo</option>
                    <option value="CD">Congo, the Democratic Republic of the</option>
                    <option value="CK">Cook Islands</option>
                    <option value="CR">Costa Rica</option>
                    <option value="CI">Côte d'Ivoire</option>
                    <option value="HR">Croatia</option>
                    <option value="CU">Cuba</option>
                    <option value="CW">Curaçao</option>
                    <option value="CY">Cyprus</option>
                    <option value="CZ">Czech Republic</option>
                    <option value="DK">Denmark</option>
                    <option value="DJ">Djibouti</option>
                    <option value="DM">Dominica</option>
                    <option value="DO">Dominican Republic</option>
                    <option value="EC">Ecuador</option>
                    <option value="EG">Egypt</option>
                    <option value="SV">El Salvador</option>
                    <option value="GQ">Equatorial Guinea</option>
                    <option value="ER">Eritrea</option>
                    <option value="EE">Estonia</option>
                    <option value="ET">Ethiopia</option>
                    <option value="FK">Falkland Islands (Malvinas)</option>
                    <option value="FO">Faroe Islands</option>
                    <option value="FJ">Fiji</option>
                    <option value="FI">Finland</option>
                    <option value="FR">France</option>
                    <option value="GF">French Guiana</option>
                    <option value="PF">French Polynesia</option>
                    <option value="TF">French Southern Territories</option>
                    <option value="GA">Gabon</option>
                    <option value="GM">Gambia</option>
                    <option value="GE">Georgia</option>
                    <option value="DE">Germany</option>
                    <option value="GH">Ghana</option>
                    <option value="GI">Gibraltar</option>
                    <option value="GR">Greece</option>
                    <option value="GL">Greenland</option>
                    <option value="GD">Grenada</option>
                    <option value="GP">Guadeloupe</option>
                    <option value="GU">Guam</option>
                    <option value="GT">Guatemala</option>
                    <option value="GG">Guernsey</option>
                    <option value="GN">Guinea</option>
                    <option value="GW">Guinea-Bissau</option>
                    <option value="GY">Guyana</option>
                    <option value="HT">Haiti</option>
                    <option value="HM">Heard Island and McDonald Islands</option>
                    <option value="VA">Holy See (Vatican City State)</option>
                    <option value="HN">Honduras</option>
                    <option value="HK">Hong Kong</option>
                    <option value="HU">Hungary</option>
                    <option value="IS">Iceland</option>
                    <option value="IN">India</option>
                    <option value="ID">Indonesia</option>
                    <option value="IR">Iran, Islamic Republic of</option>
                    <option value="IQ">Iraq</option>
                    <option value="IE">Ireland</option>
                    <option value="IM">Isle of Man</option>
                    <option value="IL">Israel</option>
                    <option value="IT">Italy</option>
                    <option value="JM">Jamaica</option>
                    <option value="JP">Japan</option>
                    <option value="JE">Jersey</option>
                    <option value="JO">Jordan</option>
                    <option value="KZ">Kazakhstan</option>
                    <option value="KE">Kenya</option>
                    <option value="KI">Kiribati</option>
                    <option value="KP">Korea, Democratic People's Republic of</option>
                    <option value="KR">Korea, Republic of</option>
                    <option value="KW">Kuwait</option>
                    <option value="KG">Kyrgyzstan</option>
                    <option value="LA">Lao People's Democratic Republic</option>
                    <option value="LV">Latvia</option>
                    <option value="LB">Lebanon</option>
                    <option value="LS">Lesotho</option>
                    <option value="LR">Liberia</option>
                    <option value="LY">Libya</option>
                    <option value="LI">Liechtenstein</option>
                    <option value="LT">Lithuania</option>
                    <option value="LU">Luxembourg</option>
                    <option value="MO">Macao</option>
                    <option value="MK">Macedonia, the former Yugoslav Republic of</option>
                    <option value="MG">Madagascar</option>
                    <option value="MW">Malawi</option>
                    <option value="MY">Malaysia</option>
                    <option value="MV">Maldives</option>
                    <option value="ML">Mali</option>
                    <option value="MT">Malta</option>
                    <option value="MH">Marshall Islands</option>
                    <option value="MQ">Martinique</option>
                    <option value="MR">Mauritania</option>
                    <option value="MU">Mauritius</option>
                    <option value="YT">Mayotte</option>
                    <option value="MX">Mexico</option>
                    <option value="FM">Micronesia, Federated States of</option>
                    <option value="MD">Moldova, Republic of</option>
                    <option value="MC">Monaco</option>
                    <option value="MN">Mongolia</option>
                    <option value="ME">Montenegro</option>
                    <option value="MS">Montserrat</option>
                    <option value="MA">Morocco</option>
                    <option value="MZ">Mozambique</option>
                    <option value="MM">Myanmar</option>
                    <option value="NA">Namibia</option>
                    <option value="NR">Nauru</option>
                    <option value="NP">Nepal</option>
                    <option value="NL">Netherlands</option>
                    <option value="NC">New Caledonia</option>
                    <option value="NZ">New Zealand</option>
                    <option value="NI">Nicaragua</option>
                    <option value="NE">Niger</option>
                    <option value="NG">Nigeria</option>
                    <option value="NU">Niue</option>
                    <option value="NF">Norfolk Island</option>
                    <option value="MP">Northern Mariana Islands</option>
                    <option value="NO">Norway</option>
                    <option value="OM">Oman</option>
                    <option value="PK">Pakistan</option>
                    <option value="PW">Palau</option>
                    <option value="PS">Palestinian Territory, Occupied</option>
                    <option value="PA">Panama</option>
                    <option value="PG">Papua New Guinea</option>
                    <option value="PY">Paraguay</option>
                    <option value="PE">Peru</option>
                    <option value="PH">Philippines</option>
                    <option value="PN">Pitcairn</option>
                    <option value="PL">Poland</option>
                    <option value="PT">Portugal</option>
                    <option value="PR">Puerto Rico</option>
                    <option value="QA">Qatar</option>
                    <option value="RE">Réunion</option>
                    <option value="RO">Romania</option>
                    <option value="RU">Russian Federation</option>
                    <option value="RW">Rwanda</option>
                    <option value="BL">Saint Barthélemy</option>
                    <option value="SH">Saint Helena, Ascension and Tristan da Cunha</option>
                    <option value="KN">Saint Kitts and Nevis</option>
                    <option value="LC">Saint Lucia</option>
                    <option value="MF">Saint Martin (French part)</option>
                    <option value="PM">Saint Pierre and Miquelon</option>
                    <option value="VC">Saint Vincent and the Grenadines</option>
                    <option value="WS">Samoa</option>
                    <option value="SM">San Marino</option>
                    <option value="ST">Sao Tome and Principe</option>
                    <option value="SA">Saudi Arabia</option>
                    <option value="SN">Senegal</option>
                    <option value="RS">Serbia</option>
                    <option value="SC">Seychelles</option>
                    <option value="SL">Sierra Leone</option>
                    <option value="SG">Singapore</option>
                    <option value="SX">Sint Maarten (Dutch part)</option>
                    <option value="SK">Slovakia</option>
                    <option value="SI">Slovenia</option>
                    <option value="SB">Solomon Islands</option>
                    <option value="SO">Somalia</option>
                    <option value="ZA">South Africa</option>
                    <option value="GS">South Georgia and the South Sandwich Islands</option>
                    <option value="SS">South Sudan</option>
                    <option value="ES">Spain</option>
                    <option value="LK">Sri Lanka</option>
                    <option value="SD">Sudan</option>
                    <option value="SR">Suriname</option>
                    <option value="SJ">Svalbard and Jan Mayen</option>
                    <option value="SZ">Swaziland</option>
                    <option value="SE">Sweden</option>
                    <option value="CH">Switzerland</option>
                    <option value="SY">Syrian Arab Republic</option>
                    <option value="TW">Taiwan, Province of China</option>
                    <option value="TJ">Tajikistan</option>
                    <option value="TZ">Tanzania, United Republic of</option>
                    <option value="TH">Thailand</option>
                    <option value="TL">Timor-Leste</option>
                    <option value="TG">Togo</option>
                    <option value="TK">Tokelau</option>
                    <option value="TO">Tonga</option>
                    <option value="TT">Trinidad and Tobago</option>
                    <option value="TN">Tunisia</option>
                    <option value="TR">Turkey</option>
                    <option value="TM">Turkmenistan</option>
                    <option value="TC">Turks and Caicos Islands</option>
                    <option value="TV">Tuvalu</option>
                    <option value="UG">Uganda</option>
                    <option value="UA">Ukraine</option>
                    <option value="AE">United Arab Emirates</option>
                    <option value="GB">United Kingdom</option>
                    <option value="US">United States</option>
                    <option value="UM">United States Minor Outlying Islands</option>
                    <option value="UY">Uruguay</option>
                    <option value="UZ">Uzbekistan</option>
                    <option value="VU">Vanuatu</option>
                    <option value="VE">Venezuela, Bolivarian Republic of</option>
                    <option value="VN">Viet Nam</option>
                    <option value="VG">Virgin Islands, British</option>
                    <option value="VI">Virgin Islands, U.S.</option>
                    <option value="WF">Wallis and Futuna</option>
                    <option value="EH">Western Sahara</option>
                    <option value="YE">Yemen</option>
                    <option value="ZM">Zambia</option>
                    <option value="ZW">Zimbabwe</option>
                </select>
            </div>
            <div class="form-group">
                <label>State: *</label><br />
                <input type="text" name="state" v-model="finalData.state" />
            </div>
            <div class="form-group">
                <label>City: *</label><br />
                <input type="text" name="city" v-model="finalData.city" />
            </div>
            <div class="form-group">
                <label>Address: *</label><br />
                <input type="text" name="address" v-model="finalData.address" />
            </div>
        </div>

        <h3>Contact</h3>
        <div class="form-section">
            <div class="form-group">
                <label>First name: *</label><br />
                <input type="text" name="contact.firstName" v-model="finalData.contact.firstName" />
            </div>
            <div class="form-group">
                <label>Last name: *</label><br />
                <input type="text" name="contact.lastName" v-model="finalData.contact.lastName" />
            </div>
            <div class="form-group">
                <label>mobile: *</label><br />
                <input type="text" name="contact.mobile" v-model="finalData.contact.mobile" />
            </div>
            <div class="form-group">
                <label>Whatsapp: *</label><br />
                <input type="text" name="contact.whatsapp" v-model="finalData.contact.whatsapp" />
            </div>
        </div>

        <template v-if="!isAgent">
            <h3>Libraries Limit</h3>
            <div class="form-section">
                <div class="form-group">
                    <label>Library Add Limit: *</label><br />
                    <input type="number" name="libraryAddLimit" v-model="finalData.libraryAddLimit" />
                </div>
                <div class="form-group">
                    <label>Library Add Count:</label><br />
                    <input type="text" name="libraryAddCount" :value="finalData.libraryAddCount" disabled />
                </div>
            </div>

            <h3>Agent</h3>
            <div class="form-section">
                <div class="form-group">
                    <label>Agent:</label><br />
                    <select v-model="finalData.agent">
                        <option value=""></option>
                        <option v-for="agent in agents" :value="agent._id" :key="agent._id">{{ agent._id }} ({{ agent.name }})</option>
                    </select>
                </div>
            </div>

            <h3>Password</h3>
            <div class="form-section">
                <div class="form-group">
                    <label>Change Password:</label><br />
                    <input type="text" name="password" v-model="finalData.password" />
                </div>
            </div>
        </template>
        <div class="form-section">
            <div class="form-group block" style="margin-bottom: 20px;">
                <button type="submit">{{ submitText || 'Submit' }}</button>
            </div>
        </div>

        <hr />

        <h3>Libraries</h3>
        <div class="form-group">
            <a href="javascript:;" v-on:click="showLibrariesModal = true">Manage Libraries</a>
        </div>

        <ManageLibrariesModal v-if="showLibrariesModal"
              :userId="finalData._id"
              :libraries="finalData.libraries"
              @modalClosed="librariesModalClosed" />

        <hr />

        <h3>Comments</h3>
        <div class="form-group">
            <a href="javascript:;" v-on:click="showCommentsModal = true">Manage Comments ({{ commentsNum }})</a>
        </div>

        <CommentsModal v-if="showCommentsModal"
            :userId="finalData._id"
            @modalClosed="commentsModalClosed" />
    </form>
</template>

<script>
import ManageLibrariesModal from '@/components/global/ManageLibrariesModal.vue'
import CommentsModal from "@/components/global/CommentsModal.vue";
import { mapStores } from 'pinia'
import { useAuthStore } from '@/stores/auth.js'

export default {
    name: 'BrandForm',
    props: ['formData', 'agents', 'submitText'],
    emits: ['formSubmitted'],
    components: {
        CommentsModal,
        ManageLibrariesModal
    },
    computed: {
        ...mapStores(useAuthStore),
        isAgent() {
            return this.authStore.role === 'agent'
        }
    },
    data: function() {
        return {
            finalData: this.formData ? JSON.parse(JSON.stringify(this.formData)) : {},
            libraries: [],

            //selectedLibraries: [],
            newLibrary: null,
            country: null,

            showLibrariesModal: false,
            showCommentsModal: false,
            commentsNum: undefined
        }
    },
    created() {
        this.country = this.finalData.country.code
        this.commentsNum = this.finalData.comments?.length ?? 0
    },
    mounted() {
        const searchParams = new URLSearchParams(window.location.search)
        if (searchParams.has('comments')) {
            this.$nextTick(() => {
                this.$refs.comments?.scrollIntoView()
            })
        }
    },
    methods: {
        cleanFinalData() {
            delete this.finalData.__v
            delete this.finalData.updatedAt
            delete this.finalData.createdAt
            delete this.finalData.lastConnect
            delete this.finalData.lastVersion
            delete this.finalData.libraryRequests
            delete this.finalData.devices
            delete this.finalData.libraryAddCount
            delete this.finalData.libraries
            if (this.isAgent) {
                delete this.finalData.libraryAddLimit
                delete this.finalData.agent
                delete this.finalData.password
            }
        },
        submitForm(e) {
            e.preventDefault()
            this.finalData.country = this.country
            this.cleanFinalData()
            this.$emit('formSubmitted', this.finalData)
        },
        librariesModalClosed(save, libraries) {
            if (save === true && libraries) {
                this.finalData.libraries = libraries
            }
            this.showLibrariesModal = false
        },
        commentsModalClosed(commentsNum) {
            this.showCommentsModal = false
            this.commentsNum = commentsNum
        }
    }
}
</script>

<style lang="scss" scoped>
.block {
    display: block !important;
}
h1, h2, h3 {
    margin: 15px 0 5px;
}
.form-group {
    display: inline-block;
    width: 100%;
    max-width: 400px;
}
.form-section {
    display: grid;
    gap: 20px;
    width: 100%;
    max-width: 1500px;
}

@media screen and (min-width: 550px) {
    .form-section {
        max-width: 850px;
        grid-template-columns: repeat(2, 1fr);
    }
}
@media screen and (min-width: 900px) {
    .form-section {
        max-width: 1250px;
        grid-template-columns: repeat(3, 1fr);
    }
}
</style>
